/**
 * Authentication API Service
 * - Handles OTP sending and verification
 * - Manages login authentication flow
 */

import apiClient from "./apiClient";

// Send OTP to mobile number for login
export const sendOTPAPI = async (mobile) => {
  const response = await apiClient.post(`/tailmission/api/v1/auth/send_otp`, {
    mobile,
    otp_type: "login"
  });
  return response;
};

// Verify OTP and complete login
export const verifyOTPAPI = async (mobile, otp) => {
  const response = await apiClient.post(`/tailmission/api/v1/auth/verify_otp`, {
    mobile,
    otp
  });
  return response;
};

export default { sendOTPAPI, verifyOTPAPI };
